<ng-container [formGroup]="formAirportFilter">
    <label class="container" *ngFor="let airport of availableAirports; let i = index">
        <input type="checkbox" (click)="sendFilterOptionAirport(airport, i)" [value]="airport"
            [formControl]="airportFilterArray.at(i)">
        <span class="checkmark"></span>
        {{airport.IATACode}} - {{airport.name}}, {{airport.city}} - {{airport.country}} </label>
</ng-container>